<template>
  <div class="prowerSelect">
    <!-- <div class="powerName c8c8" v-if="onLine">
      <span class="fz14 disblock">设备列表：</span>
      <div class="selPower mt10 flex center-row">
        <span class="selPower_name mr10 fz12" @click="seeMoreStation">{{
          this.stationObj.stationName || "1222"
        }}</span>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="seeMoreStation"
        ></el-button>
      </div>
    </div> -->
    <div class="powerName c8c8 flex center-row">
      <!-- <span class="fz14">设备列表：</span> -->
      <div class="selPower flex center-row">
        <!-- <span class="selPower_name mr10 fz12" @click="seeMoreStation">{{
          this.stationObj.gatewayName || "设备"
        }}</span> -->
        <el-button type="primary" size="small" icon="el-icon-search" @click="seeMoreStation">{{$t('realtimeinfo.checkDev')}}</el-button>
      </div>
    </div>
    <el-dialog :title="tit" width="75%" :visible.sync="selectProwerStation" :before-close='beforeclose'>
      <div>
        <div class="boxClass fz14" v-if='isdevice'>
          <div class="flex center-row select_searchPrower">
                        {{$t('manipulation.devName')}}：<el-input v-model="searchName" :placeholder="$t('userManage.pleInputProName')" class="mr20" clearable></el-input>
            <!-- <div class="mr10">
                经销商：
                <el-select clearable v-model="dealer" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.realName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div> -->
            <div class="mr10">
             {{$t('fileManage.areaName')}}：
              <el-cascader clearable v-model="installSite" :options="optionsSite" :props="{ expandTrigger: 'hover' }"
                @change="handleChange"></el-cascader>

            </div>
            <div>

              <span class="fz14 c6 ml20 mr0">{{$t('manipulation.elevatorBrand')}}：</span>
              <el-select v-model="deviceNoInput" clearable >
                <el-option v-for="(item,index) in typeList1" :key="index" :label="item.dictValue" :value="item.dictKey">
                </el-option>
              </el-select>
              <span class="fz14 c6 ml20">{{$t('stationModal.devBh')}}：</span>
              <el-input v-model.trim="sawModelInput" clearable  class="handle-input"></el-input>

              <el-button type="primary" class="ml10" size="small" icon="el-icon-search" @click="searchPrower">
              </el-button>
            </div>
          </div>
          <div class="mt20 commenSelTable">
            <el-table :data="tableData" border highlight-current-row @cell-dblclick="dbHandle"
              @current-change="handleCurrentChange" style="width: 100%">
              <el-table-column :prop="item.prop" :label="item.label" v-for="(item,index) in column" :key='index'
                align="center">
              </el-table-column>

              <el-table-column prop="installTime" :label="$t('realdetile.opera')">
                <template slot-scope="scope">
                  <el-button type="primary" size="small" @click="addGroup(scope.row)">{{$t('manipulation.sure')}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
           <div class="txtr mt20">
              <el-pagination layout="total, prev, pager, next" :page-size="pagesize" :currentPage="pagecurrent" background :total="pagetotal"
                @current-change="currentChangeHandle"></el-pagination>
            </div>
        </div>
        <div v-if='!isdevice'>
          <div style="margin-bottom:20px">
            <el-button type="primary" icon="el-icon-back" style="margin-right:20px" @click="goblack">{{$t('realdetile.return')}}</el-button>
            <span>{{$t('manipulation.airNum')}}：</span>
            <el-input v-model.trim="devNumber" clearable :placeholder="$t('fileInfo.pleInputAirCode')" class="handle-input "
              style="width:160px;margin-right:15px"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="seachkt">{{$t('tagsView.search')}} </el-button>
          </div>
          <div>
            <el-table :data="devicelist" style="width: 100%">
              <el-table-column v-for="(item,index) in column1" :prop="item.prop" :label="item.label" align="center"
                :key="index" :width="item.width">
              </el-table-column>
              <el-table-column :label="$t('realdetile.opera')" width="200" align="center">
                <template slot-scope="scope">
                  <el-button type="primary" @click="changedevice(scope.row)">{{$t('manipulation.sure')}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
           <div class="txtr mt20">
              <el-pagination layout="total, prev, pager, next" :page-size="pagesize1" background :total="pagetotal1"
                @current-change="currentChangeHandle1"></el-pagination>
            </div>
        </div>
       
      </div>
      <!-- <div slot="footer" class="dialog-footer">
                <el-button @click="cacelDialog">取 消</el-button>
            </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { queryGatewayList, queryDealerList } from "@/api/deviceOverview/common";
import { getDeviceListById } from "@/api/devicemon";
import { dictList, } from '@/api/deviceOverview/file';
import { MESSAGE } from "@/util/elementHandle.js";
import { getProvinceCity } from "@/util/provinceCity.js";
import { mapGetters } from "vuex";
export default {
  props: ["linkbreak", "onLine"],
  data() {
    return {
      selectProwerStation: false,
      searchName: "",
      pagetotal: 0,
      pagesize: 5,
      pagetotal1: 0,
      pagesize1: 10,
      currentPage:1,
      pagecurrent: 1,
      pagecurrent1: 1,
      tableData: [],
      curSelObj: {},
      options: [],
      value: [],
      optionsSite: [],
      dealer: "",
      installTime: "",
      installSite: "",
      sawModelInput: "",
      deviceNoInput: "",
      typeList1: [],
      column: [
        { prop: 'index', label: this.$t('realdetile.serNum') },
        { prop: 'projectName', label: this.$t('manipulation.devName') },
        { prop: 'address', label: this.$t('manipulation.installAddress') },
        { prop: 'deviceCount', label: this.$t('realdetile.airconditionalNum') },
        { prop: 'organization', label: this.$t('realdetile.contUnit') },
        { prop: 'status', label: this.$t('realdetile.projectStatus') },
      ],
      column1: [
        { prop: 'devNumber', label: this.$t('manipulation.airNum') },
        { prop: 'devModelName', label:this.$t('manipulation.airModel')  },
        { prop: 'onlineFlag1', label: this.$t('manipulation.comStatus') },
        { prop: 'workStatus1', label: this.$t('manipulation.workStatus') },
        { prop: 'runStatus1', label: this.$t('manipulation.operaMode')},
      ],
      isdevice: true,
      devNumber: '',
      devicelist: [],
      page:{
        size:10,
        current:1
      },
      tit: this.$t('realtimeinfo.checkDev'),
    };
  },
  created() { },
  methods: {
    seachkt(){
      this.getdevicelist(this.curSelObj)
    },
    init() {
      this.searchName = ''
      this.installSite = []
      this.sawModelInput=''
      this.deviceNoInput = ''
    },
    // 空调列表
    getdevicelist(data) {
     
      getDeviceListById({ id: data.id, ...this.page,devNumber:this.devNumber }).then(res => {
        if (res.data.code === 200) {
          res.data.data.records.map((item, index) => {
            item.index = index + 1
              item.workStatus == 0 ? item.workStatus1 = this.$t('realtimeinfo.turnOff'): item.workStatus == 1?item.workStatus1 = this.$t('realtimeinfo.powerOn'):''
            item.runStatus == 0 ? item.runStatus1 = this.$t('manipulation.manual') : item.runStatus == 1 ?item.runStatus1 = this.$t('manipulation.timing'):''
            item.onlineFlag == 0 ? item.onlineFlag1 = this.$t('realtimeinfo.offLine') : item.onlineFlag == 1?item.onlineFlag1 = this.$t('realtimeinfo.onLine') : ''
          })
          this.devicelist = res.data.data.records
          this.pagetotal1 = res.data.data.total
          // this.current = res.data.data.current
        }
      })
    },
    getdictList() {
      // 电梯
      dictList({ code: "elevator_brand" }).then(res => {
        if (res.data.code === 200) {
          this.typeList1 = res.data.data[0].children
        }
      })
    },
    seeMoreStation() {
      this.selectProwerStation = true;
      this.getStationList();
      this.getdictList()
    },
    searchPrower() {
      this.pagecurrent = 1;
      this.getStationList();
      this.getdictList()
    },
    getStationList() {
      let obj = {
        projectName: this.searchName,
        current: this.pagecurrent,
        size: this.pagesize,
      };
      this.dealer && (obj.dealerId = this.dealer);
      if (this.installSite) {
        obj.province = this.installSite[0] ? this.installSite[0] + this.$t('fileManage.province') : "";
        obj.city = this.installSite[1] ? this.installSite[1] + this.$t('fileManage.city') : "";
      }
      if (this.installTime) {
        obj.beginTime = this.installTime[0];
        obj.endTime = this.installTime[1];
      }
      obj.elevatorBrand = this.deviceNoInput;
      obj.devNumber = this.sawModelInput;
      queryGatewayList(obj).then((res) => {
        console.log(res, "---");
        if (res.data.code === 200) {
          res.data.data.records.map((item, index) => {
            item.index = index + 1
             item.status = item.status == 0 ? this.$t('fileManage.debug') : this.$t('fileManage.set')
          })
          this.tableData = res.data.data.records;
          this.pagetotal = res.data.data.total * 1;
        } else {
          MESSAGE({
            text: res.data.msg,
            type: "error",
          });
        }
      });
    },
    addGroup(row) {
      this.curSelObj = row;
      this.page.current = 1
      // if (!this.curSelObj.gatewayId) {
      //   MESSAGE({
      //     text: "请至少选择一个",
      //     type: "error",
      //   });
      //   return;
      // }
      // 设置默认配电站


      if (!this.onLine) {
        let obj = {
          ...this.curSelObj, type1: 'project', devid: this.stationObj.devid,
          onenetId: this.stationObj.onenetId, devcode: this.stationObj.devCode
        }

        this.$store
          .dispatch("SetDefaultStationFun", obj)
          .then((res) => {
            console.log("----sdfs");
            MESSAGE({
               text: this.$t('stationModal.setSuc')
            });
            this.selectProwerStation = false;

            this.$emit("selectStation", this.curSelObj);
          })
          .catch(() => { });

      } else {
        this.getdevicelist(row)
        this.isdevice = false
        this.tit = this.$t('realdetile.choAir')
      }
    },
    changedevice(val) {
      let obj = {
        ...val, type1: 'device', proid: this.stationObj.proid
      }
      this.$store
        .dispatch("SetDefaultStationFun", obj)
        .then((res) => {
          console.log("----sdfs");
          MESSAGE({
             text: this.$t('stationModal.setSuc')
          });
          this.selectProwerStation = false;
          let res1 = [val, this.curSelObj]
          this.isdevice = true
          this.$emit("selectStation", res1);
        })
        .catch(() => { });

    },
    goblack() {
       this.tit = this.$t('realtimeinfo.checkDev')
      this.isdevice = true
    },
    handleCurrentChange(row) {
      console.log(row, "setHandle--");
      this.curSelObj = row;
    },
    cacelDialog() {
      this.selectProwerStation = false;
    },
    beforeclose() {
      this.isdevice = true,
        this.selectProwerStation = false;
    },
    currentChangeHandle(val) {
      this.pagecurrent = val;
      this.getStationList();
    },
    currentChangeHandle1(val) {
      this.page.current = val;
      this.getdevicelist(this.curSelObj)
    },
    handleChange() { },
    dbHandle(row) {
      console.log(row, "---row--");
    },
    getDealerList() {
      queryDealerList().then((res) => {
        if (res.data.code === 200) {
          if (!res.data.data) {
            return;
          }
          this.options = res.data.data;
          if (this.options.length) {
            this.options.unshift({ id: "", realName: this.$t('stationModal.all') });
          }
        } else {
          MESSAGE({
            text: res.data.msg,
            type: "error",
          });
        }
      });
    },
  },
  computed: {
    ...mapGetters(["stationObj"]),
  },
  watch: {},
  created() {
    this.optionsSite = getProvinceCity();
    // this.getDealerList()
  },
};
</script>


<style lang='scss' scope>
.selPower_name {
  flex: 1;
  height: 30px;
  font-size: 12px;
  line-height: 30px;
  border: 1px solid #bdbdbd;
  padding: 0 10px;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-radius: 5px;
  min-width: 120px;
  cursor: pointer;
}

.search {
  height: 32px;
  padding: 8px 12px;
  position: relative;
  input {
    width: calc(100% - 50px);
    border-radius: 16px;
    padding: 0 40px 0 10px;
    height: 32px;
    border: none;
    font-size: 12px;
  }
  .el-icon-search {
    position: absolute;
    top: 16px;
    bottom: 0;
    right: 30px;
    cursor: pointer;
  }
}
.select_searchPrower {
  .el-input {
    width: auto;
  }
  input {
    width: 180px;
  }
}
.boxClass {
  border: 1px dashed #324170;
  border-radius: 10px;
  padding: 40px;
}
.status {
  width: 10px;
  height: 10px;
  background: chartreuse;
  display: inline-block;
  border-radius: 50%;
}
.status1 {
  background: chartreuse;
}
.status0 {
  background: #ccc;
}
</style>
